module.exports = __webpack_public_path__ + "bd404ce51c388d153db43a84f4d44b47.gif";